import { useEffect, useState } from "react";
import { useValue } from "@tldraw/state-react";
import type { Editor } from "./canvas";
import type { Sheet, Trace } from "../shared/schema";
import { taskQueue } from "../shared/images";
const renderPreview = taskQueue(1);
export function SheetPreview({
  editor,
  sheet,
}: {
  editor: Editor;
  sheet: Sheet | Trace;
}) {
  const [src, setSrc] = useState("");
  const revision = useValue(
    "sheet preview contents",
    () =>
      JSON.stringify(
        editor
          .getCurrentPageShapes()
          .filter((s) => s.id === sheet.id || editor.hasAncestor(s, sheet.id)),
      ),
    [editor, sheet.id],
  );
  useEffect(() => {
    let live = true,
      url = "";
    const timer = setTimeout(() => {
      void renderPreview(async () => {
        if (!live) return;
        try {
          const bounds = editor.getShapePageBounds(sheet.id);
          if (!bounds) return;
          const result = await editor.toImage([sheet.id], {
            format: "png",
            bounds,
            padding: 0,
            background: true,
            scale: Math.min(1, 240 / Math.max(bounds.w, bounds.h)),
            pixelRatio: 1,
          });
          if (live) {
            url = URL.createObjectURL(result.blob);
            setSrc(url);
          }
        } catch {
          /* The real sheet remains navigable when a thumbnail fails. */
        }
      });
    }, 500);
    return () => {
      live = false;
      clearTimeout(timer);
      if (url) URL.revokeObjectURL(url);
    };
  }, [editor, sheet.id, revision]);
  return src ? (
    <img className="sheet-thumbnail" src={src} alt="" />
  ) : (
    <span className="sheet-thumbnail blank-thumbnail">
      {sheet.type === "sheet" ? sheet.props.paper : "TRACE"}
    </span>
  );
}
